const RESPONSIVE_WIDTHS = [375, 768, 1024, 1920] as const;

export function appendWidth(src: string, width: number): string {
  const url = new URL(src);
  url.searchParams.set('width', String(width));
  return url.toString();
}

export function getResponsiveImgProps(src: string, sizes: string) {
  return {
    srcSet: RESPONSIVE_WIDTHS.map(w => `${appendWidth(src, w)} ${w}w`).join(
      ', '
    ),
    sizes
  };
}
